// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback } from 'react';
import isObject from 'lodash/isObject';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireErrorAnalytics } from '@atlassian/ui-modifications-analytics';
import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../../../controllers/issue-adjustments/main';
import { getAnalytics } from '../../../../../../../controllers/view-configuration';
import { BRIDGE_ERROR_TYPES } from './constants';
var isValidPayload = function isValidPayload(payload) {
  return payload !== undefined && isObject(payload) && BRIDGE_ERROR_TYPES.includes(payload.error) && (!payload.changeId || typeof payload.changeId === 'string');
};
export var useOnBridgeError = function useOnBridgeError(_ref) {
  var appId = _ref.appId;
  var _useIssueAdjustmentsA = useIssueAdjustmentsActions(),
    setError = _useIssueAdjustmentsA.setError,
    unregisterFields = _useIssueAdjustmentsA.unregisterFields;
  var viewType = useViewType();
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  return useCallback(function (payload) {
    if (!isValidPayload(payload)) {
      return;
    }
    var changeId = payload.changeId,
      error = payload.error;
    if (changeId) {
      unregisterFields({
        changeId: changeId,
        appId: appId
      });
    }
    setError({
      errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE'
    });
    getAnalytics(viewType).stopTTI({
      completionStatus: 'error',
      viewType: viewType
    });
    var UIMLoggableError = new Error("An ".concat(error, " occurred in the UI Modifications code in the Jira Bridge"));
    fireErrorAnalytics({
      error: UIMLoggableError,
      id: 'UIModificationsJiraBridge',
      viewType: viewType,
      attributes: {
        type: error
      },
      event: createAnalyticsEvent({})
    });
  }, [setError, unregisterFields, createAnalyticsEvent, viewType, appId]);
};